import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { OptionsNgxOwCarouselService } from 'dmmp-services'

@Component({
  selector: 'dmmp-banner-video-image',
  templateUrl: './banner-video-image.component.html'
})
export class BannerVideoImageComponent implements OnInit {

  @Input() module
  @Input() identifier
  @Input() defaultClass
  @Input() detailLayout
  configCarousel
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()
  videoState
  videos = []
  images = []

  constructor(private options: OptionsNgxOwCarouselService) { }

  ngOnInit(): void {
    this.configCarousel = this.options.configurationBenefits(this.module)
    this.configVideosAndImages()
  }

  changeSlide(movInfo) {
    this.videoState = movInfo
  }

  configVideosAndImages() {
    switch (this.detailLayout?.identifier) {
      case 'basic_page': {
        this.images = this.detailLayout?.banner
        break
      }
      case 'event': {
        this.videos = this.detailLayout?.video_related
        this.images = this.detailLayout?.image
        break
      }
      case 'blog': {
        this.images = this.detailLayout?.image
        break
      }
      case 'news': {
        this.detailLayout?.image_items?.forEach(imageItem => {
          this.images.push(imageItem?.image[0])
        })
        break
      }
    }
  }

}
